import styled from "styled-components";

import { FakeFilterText } from "app/pages/app-intelligence/common-components/fake-filter/styledComponents";

export const BacklinksFrameContainer = styled.span`
    flex-grow: 1;
    overflow-x: hidden;
    width: 100%;
    ${FakeFilterText} {
        padding-right: 5px;
    }
`;

export const BacklinksPageFrameWrapper = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 43px;
    height: 100%;
`;
